import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(private http: HttpClient) { }

  getDepartments(): Observable<any> {
    const url = `${environment.apiOrigin}/api/departments`;
    return this.http.get(url);
  }

  getDepartment(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/departments/${id}`;
    return this.http.get(url);
  }

  deleteDepartment(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/departments/${id}`;
    return this.http.delete(url);
  }

  saveDepartment(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/departments`;
    if (value.id) {
      return this.http.post(url, value);
    } else {
      return this.http.put(url, value);
    }
  }
}
